// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__34hZV","label":"Labeled_label__37bB6","divider":"Labeled_divider__1u-n3"};